import { applyEntities } from '@zerops/fe/core';
import { ServerParkAccessBaseState } from './server-park-access-base.model';
import { ModuleTokens } from './server-park-access-base.constant';

const initialState = new ServerParkAccessBaseState();

export function reducer(
  state = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actions: any
): ServerParkAccessBaseState {
  return applyEntities<ServerParkAccessBaseState>(
    state,
    [ ModuleTokens.Name ],
    actions
  );
}
